import { Item } from './items.model';
import { Quality } from './quality.model';

export class TopItem {
  item!: Item | undefined;
  totalPrice!: number;
  amount!: number;
}

export interface AfmStats {
  usersCount: number;
  craftCount: number;
  totalIncome: number;
  totalCost: number;
  flipsProfit: number;
}
